import { useMemo } from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const usePanoramaEnabled = () => {
  const { config } = useApplicationContext();

  return useMemo(() => config.get<boolean>('HouseCard.panorama.Enabled'), [config]);
};
